import { render, staticRenderFns } from "./OrdersSidebar.vue?vue&type=template&id=6fa8a954&"
import script from "./OrdersSidebar.vue?vue&type=script&lang=js&"
export * from "./OrdersSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports